import { combineReducers } from "redux";
import { user } from "./user";
import { activePage } from "./active-page";
import { activeCompany } from "./active-company";
import { hidePopup } from "./hide-popup";
import { library } from "./library";
import { calendar } from "./calendar";
import { clients } from "./clients";
import { singleClient } from "./single-client";
import { lists } from "./lists";
import { singleList } from "./single-list";
import { newList } from "./new-list";
import { overview } from "./overview";
import { newSpace } from "./new-space";
import { validate } from "./validate";
import { company } from "./company";
import { pipeline } from "./pipeline";
import { registration } from "./registration";
import { resetPassword } from "./reset-password";
import { authentication } from "./authentication";
import { invitation } from "./invitation";
import { deliveries } from "./deliveries";
import { campaigns } from "./campaigns";
import { contactLists } from "./contact-lists";
import { singleContactList } from "./single-contact-list";
import { templates } from "./templates";
import { newTemplate } from "./new-template";
import { singleTemplate } from "./single-template";
import { singleCampaign } from "./single-campaign";
import { universal } from "./universal";

const appReducer = combineReducers({
  user,
  activePage,
  activeCompany,
  hidePopup,
  overview,
  library,
  calendar,
  clients,
  singleClient,
  lists,
  singleList,
  newList,
  newSpace,
  validate,
  company,
  pipeline,
  registration,
  resetPassword,
  authentication,
  invitation,
  deliveries,
  campaigns,
  contactLists,
  singleContactList,
  templates,
  newTemplate,
  singleTemplate,
  singleCampaign,
  universal,
});

const rootReducer = (state, action) => {
  if (action.type === "USER_SIGNOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
